import actions from "../../../actions";

export const pollForEventUpdateStatus = async ({
  onError,
  refetch,
  event_id,
}: {
  event_id: string;
  onError: (err: string) => void;
  refetch: () => Promise<any>;
}) => {
  console.log("Poll Event Status");
  const searchParams = new URLSearchParams(window.location.search);
  const updateId = searchParams.get("update_id");
  const sleep = (milliseconds: number) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  if (updateId) {
    let attempts = 0;
    let didFind = false;

    do {
      console.log("Attempt: ", attempts);
      let serverEventUpdate: any;
      let failed = false;
      try {
        serverEventUpdate = await actions.ADMIN.fetchEventUpdate(
          event_id!,
          updateId
        );
      } catch (err) {
        console.log(err);
        failed = true;
      }

      if (
        !failed &&
        (!serverEventUpdate || serverEventUpdate.status === "COMPLETE")
      ) {
        didFind = true;
        searchParams.delete("update_id");

        const newUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          searchParams.toString();
        window.history.pushState({ path: newUrl }, "", newUrl);

        if (
          serverEventUpdate &&
          serverEventUpdate.status === "COMPLETE" &&
          serverEventUpdate.error
        ) {
          console.log(
            "Found Update: ",
            JSON.stringify(serverEventUpdate, null, 2)
          );
          onError(serverEventUpdate.error.message || serverEventUpdate.error);
          // dialog({
          //   text: serverEventUpdate.error.message || serverEventUpdate.error,
          // });
          return false;
        } else {
          await refetch();
          // await refetchEvent({ silent: true });
        }
        break;
      } else {
        await sleep(3000);
        attempts += 1;
      }
    } while (attempts < 15);

    return didFind;
  }

  return false;
};
